<template>
  <div class="personal-panel">
    <div
      class="personal-desc"
      :style="{ background: this.$store.state.app.themeColor }"
    >
      <div class="avatar-container">
        <el-avatar :size="80" :src="user.avatar"></el-avatar>
      </div>
      <div class="name-role">
        <span class="sender">{{ user.nick }} </span>
      </div>
      <!-- <div class="registe-info">
        <span class="registe-info">
          <li class="fa fa-bookmark-o fa-fw"></li>
          订购版本：高级版（104天后到期）
        </span>
      </div> -->
    </div>
    <!-- <div class="personal-relation">
      <span class="relation-item">followers</span>
      <span class="relation-item">watches</span>
      <span class="relation-item">friends</span>
    </div> -->

    <div class="personal-relation">
      <span style="color:#f56c6c">
        <li class="fa fa-bookmark fa-fw"></li>
        订购版本：{{ getItemCodeDesc(user.itemCode) }}
        （
        <span v-if="getDistanceDay(new Date(), user.expiredDate) > -1">
          {{ getDistanceDay(new Date(), user.expiredDate) }}
          天后到期</span
        >
        <span v-else>
          已过期{{ getDistanceDay(new Date(), user.expiredDate) * -1 }}天</span
        >）
      </span>
    </div>
    <div class="main-operation">
      <span class="main-operation-item">
        <el-button
          size="small"
          icon="fa fa-user fa-fw"
          @click="toPage('/user/profile')"
        >
          个人中心</el-button
        >
      </span>
      <span class="main-operation-item">
        <el-button
          size="small"
          icon="fa fa-key fa-fw"
          type="success"
          plain
          @click="toOrderPage"
        >
          续费</el-button
        >
      </span>
    </div>
    <div class="other-operation">
      <div class="other-operation-item" @click="toPage('/user/notice')">
        <li class="fa fa-envelope fa-fw"></li>
        站内通知
      </div>
      <div class="other-operation-item" @click="toPage('/user/systemLog')">
        <li class="fa fa-file-text fa-fw"></li>
        操作记录
      </div>
    </div>
    <div class="personal-footer" @click="logout">
      <li class="fa fa-sign-out"></li>
      退出登录
    </div>
  </div>
</template>

<script>
import DateUtils from "@/utils/datetime";
import ToolUtils from "@/utils/tools";
import { mapState } from "vuex";
export default {
  name: "PersonalPanel",
  props: {
    user: {
      type: Object,
      default: {
        nick: "",
        avatar: "@/assets/user.png",
        registerDate: "无"
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    toOrderPage: function() {
      this.$alert(
        "续订成功后，请从 淘宝后台->“我的服务” 重新登录e店长方能生效。（淘宝后台地址：https://fuwu.taobao.com/ser/my_service.htm）",
        "提示",
        {
          confirmButtonText: "确定",
          callback: action => {
            window.open(this.global.APP_FUWU_ORDER_URL);
          }
        }
      );
    },
    toPage: function(path) {
      this.$router.push(path);
    },
    getItemCodeDesc: function(itemCode) {
      return ToolUtils.getItemCodeDesc(itemCode);
    },
    getDistanceDay: function(startDate, endDate) {
      return DateUtils.getDistanceDay(startDate, endDate);
    },
    // 退出登录
    logout: function() {
      this.$confirm("确认退出吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          console.log("开始退出。。。");
          sessionStorage.removeItem("edzUser");
          this.$api.login
            .loginout()
            .then(res => {
              console.log("退出登录", res);
              this.$router.push("/login");
            })
            .catch(function(res) {
              console.error(res);
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.personal-panel {
  font-size: 14px;
  width: 300px;
  text-align: center;
  border-color: rgba(180, 190, 190, 0.2);
  border-width: 1px;
  border-style: solid;
  background: rgba(182, 172, 172, 0.1);
  margin: -14px;
}
.personal-desc {
  padding: 15px;
  color: #fff;
}
/**
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 90px;
} */
.name-role {
  font-size: 16px;
  padding: 5px;
}
.personal-relation {
  font-size: 14px;
  padding: 12px;
  margin-right: 1px;
  background: rgba(200, 209, 204, 0.3);
}
.relation-item {
  padding: 12px;
}
.relation-item:hover {
  cursor: pointer;
  color: rgb(19, 138, 156);
}
.main-operation {
  padding: 8px;
  margin-right: 1px;
  /* background: rgba(175, 182, 179, 0.3); */
  border-color: rgba(201, 206, 206, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.main-operation-item {
  margin: 15px;
}
.other-operation {
  padding: 15px;
  margin-right: 1px;
  text-align: left;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.other-operation-item {
  padding: 12px;
}
.other-operation-item:hover {
  cursor: pointer;
  background: #9e94941e;
  color: #409eff;
}
.personal-footer {
  margin-right: 1px;
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: rgba(180, 190, 190, 0.2);
  border-top-width: 1px;
  border-top-style: solid;
}
.personal-footer:hover {
  cursor: pointer;
  color: #409eff;
  background: #b1a6a61e;
}
</style>



// WEBPACK FOOTER //
// src/views/Core/PersonalPanel.vue